export default __webpack_public_path__ + "static/media/hero.53c4d4f3.png";